/**
 * Studio Context — Active project state
 */

import { create } from "zustand";

export interface StudioProject {
	id: string;
	name: string;
	loc: string;
	img?: string;
	stage: string;
}

interface StudioState {
	activeProjectId: string | null;
	activeProject: StudioProject | null;
	setActiveProject: (project: StudioProject | null) => void;
	projects: StudioProject[];
	setProjects: (projects: StudioProject[]) => void;
	requestCount: number;
	setRequestCount: (count: number) => void;
	/** Back to the empty state, for a role switch. */
	reset: () => void;
}

const initialState = {
	activeProjectId: null,
	activeProject: null,
	projects: [],
	requestCount: 0,
};

export const useStudioStore = create<StudioState>((set) => ({
	...initialState,
	setActiveProject: (project) =>
		set({
			activeProjectId: project?.id ?? null,
			activeProject: project,
		}),
	setProjects: (projects) => set({ projects }),
	setRequestCount: (count) => set({ requestCount: count }),
	reset: () => set(initialState),
}));
